import reportError from 'ha/helpers/bugsnag/reportError';
import { updateSearchParams, setPreviousParams } from './actions';
import loadSearchResults from './loadSearchResults';
import loadUniversities from './loadUniversities';
import loadCitiesNearby from './loadCitiesNearby';
import saveSearch from './saveSearch';

import { getSearchParams } from '../selectors';

export default (params = {}) => (dispatch, getState) => {
  dispatch(updateSearchParams(params));

  const searchParams = getSearchParams(getState());

  /*
    We call loadSearchResults -/geonames/search-city separately,
    because we call external geocoder first to get a geo data and put it to the cache after,
    so the following calls:
      loadUniversities - /pois
      loadCitiesNearby - /geonames/cities
    will get data from our cache and that will reduce a load on external API
  */
  return dispatch(
    loadSearchResults(searchParams, { localizedKind: params.localizedKind }),
  )
    .then(() =>
      Promise.all([
        dispatch(loadUniversities(searchParams)),
        dispatch(loadCitiesNearby(searchParams)),
      ]),
    )
    .then(() => {
      dispatch(saveSearch());
      dispatch(setPreviousParams(searchParams));
    })
    .catch(reportError);
};
